// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__163hb","title":"Header_title__1PEzU","left":"Header_left__1iJUy","clinicName":"Header_clinicName__8c54G"};